import type { ContactCenterLDIdentity } from '@servicetitan/contactcenter-agent-inbox-mfe-loader';

/**
 * Builds the `featureFlagIdentity` loader setting from the signed-in user. The keys match the
 * ones `FeatureFlagModule` puts in its LaunchDarkly context: the network org ID and the
 * Titan user UUID.
 * @param user - the signed-in user from `useAuth`
 * @returns the identity to send to an Agent Inbox loader
 */
export function buildContactCenterLDIdentity(user: {
  id: string;
  org: { id: string };
}): ContactCenterLDIdentity {
  return {
    orgKey: user.org.id,
    userKey: user.id,
  };
}
